import styled from '@emotion/styled'

import { theme } from 'styles/theme/hav-theme'

export const SearchContentStyled = styled.div`
  ${({ width }: { width: string }) =>
    `
      width: ${width};

      .MuiOutlinedInput-root {
        padding: 0 ${theme.spacing.sm} 0 0;
        background-color: ${theme.colors.neutral.white};
      }
    `}
`

export const ColumnDivOptionsStyled = styled.div`
  ${({
    maxwidth,
    optionsmaxheight,
    isRightSided
  }: {
    maxwidth: string
    optionsmaxheight: string
    isRightSided: boolean
  }) =>
    `
      width: ${maxwidth};
      max-width: 100%;
      height: auto;
      max-height: ${optionsmaxheight};
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      position: absolute;
      ${isRightSided ? 'right: 15px;' : ''}
      padding: ${theme.spacing.sm};
      background-color: ${theme.colors.neutral.white};
      z-index: 1000;
      box-shadow: ${theme.effects.boxShadow['rule-01']};
      transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
      border-radius: ${theme.shapes.borderRadius.sm};
    `}
`
export const OverviewResultsStyled = styled.span`
  ${({ open }: { open: boolean }) =>
    `
      display: ${open ? 'inherit' : 'none'};
      justify-content: center;
      color: ${theme.colors.neutral.high};
      font-family: ${theme.typography.family.primary};
      font-weight: ${theme.typography.weight.lg};
      font-size: ${theme.typography.sizes['2xs']};
      line-height: ${theme.typography.lineHeight.lg};
    `}
`

export const OptionsList = styled.div`
  ${({ hasOverflow }: { hasOverflow: boolean }) =>
    `
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: ${hasOverflow ? theme.spacing.sm : '0'};

      ::-webkit-scrollbar {
        width: ${theme.spacing.sm};
      }

      ::-webkit-scrollbar-track {
        background: ${theme.colors.neutral.clear};
        border-radius: ${theme.shapes.borderRadius.md};
      }

      ::-webkit-scrollbar-thumb {
        border: none;
        background: ${theme.colors.neutral.light};
      }
    `}
`

export const ContentDivider = styled.div`
  ${`
      min-height: 1px;
      width: 100%;
      margin: ${theme.spacing.xm} 0;
      border-radius: ${theme.shapes.borderRadius.md};
      background-color: ${theme.colors.neutral.lighthover};
    `}
`
export const DivRow = styled.div`
  ${`
    display: flex;
    align-items:center;
    padding:10px;
    gap:10px;
    color:${theme.colors.neutral.high};
    `}

  svg {
    min-width: ${theme.typography.sizes.xm};
  }
`

export const RowLabels = styled.div`
  ${({ hasOverflow }: { hasOverflow: boolean }) =>
    `
      display: flex;

      padding: 0 ${theme.spacing.sm};
      margin-bottom: ${theme.spacing.xs};
      padding-right: ${hasOverflow ? theme.spacing.lg : theme.spacing.sm};

      gap: 5%};

      @media only screen and (max-width: ${theme.breakpoints.lg}px) {
        gap: ${theme.spacing.xm};
      }

      @media only screen and (max-width: ${theme.breakpoints.lg}px) {
        gap: ${theme.spacing.md};
      }
    `}
`

export const LabelText = styled.span`
  ${({ width }: { width: string }) =>
    `
      text-align: left;
      width: ${width};
      font-size: ${theme.typography.sizes.xs};
      font-weight: ${theme.typography.weight.lg};
      line-height: ${theme.typography.lineHeight.md};
      color: ${theme.colors.neutral.high};
    `}
`

export const RowOptionStyled = styled.div`
  ${({ flexwrap }: { flexwrap: string }) =>
    `
      height: min-content;
      display: flex;
      flex-direction: row;
      flex-wrap: ${flexwrap};
      margin-top: ${theme.spacing.xs};
      padding: ${theme.spacing.xs} ${theme.spacing.sm};
      border-radius: ${theme.shapes.borderRadius.sm};
      border: ${theme.shapes.borderWidth.thin} ${theme.colors.quartenary};
      gap:5%;

      @media only screen and (max-width: ${theme.breakpoints.lg}px) {
        gap: ${theme.spacing.xm};
      }

      @media only screen and (max-width: ${theme.breakpoints.lg}px) {
        gap: ${theme.spacing.md};
      }

      :hover {
        background-color: ${theme.colors.quartenary};
        cursor: pointer;
      }

      :first-of-type {
        margin-top: 0;
      }
    `}
`

export const SubColumnOptionStyled = styled.div`
  ${({ width }: { width: string }) =>
    `
      width: ${width};
      max-width: ${width};
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
    `}
`

export const SubColumnOptionDescription = styled.span`
  font-family: ${theme.typography.family.primary};
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral.high};
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  strong {
    font-size: ${theme.typography.sizes.xs};
  }
  span {
    padding: 0 ${theme.spacing.sm};
  }
`

export const ButtonCampStyled = styled.div`
  ${({ width }: { width: string }) =>
    `
      display: flex;
      width: ${width};
      margin-left: auto;
      align-items: center;
    `}
`

export const ItemFoundInfoStyled = styled.div`
  ${`
      width: max-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;
      max-width: 100%;
      padding: ${theme.spacing.lg} ${theme.spacing.xl};}

      #NoItemFoundTitle {
        text-align: center;
        margin-top: ${theme.spacing['2xm']};
        font-size: ${theme.typography.sizes.lg};
        font-weight: ${theme.typography.weight.lg};
        margin-bottom: ${theme.spacing.sm};
        color: ${theme.colors.neutral.black};
      }

      #NoItemFoundDescription {
        text-align: center;
        font-size: ${theme.typography.sizes.sm};
        line-height: ${theme.typography.lineHeight.md};
        color: ${theme.colors.neutral.black};
      }
    `}
`

export const ContainerLoadingStyled = styled.div`
  ${`
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      width: 100%;
      height: 100%;
      min-height: 100px;
    `}
`

export const ClientInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`
